import React from 'react';
import { Tags } from 'store/types';
import map from 'lodash-es/map';
import { CSSTransition } from 'react-transition-group';
import { DURATIONS } from 'utils/utils';
import { GetChipFunction } from 'hooks/useSearchControl';

export const tagsWrapTransition = ({
  tags,
  getChip,
  ref,
}: {
  tags: Tags;
  getChip: GetChipFunction;
  ref?: any;
}) => {
  const tagEntries = Object.entries(tags);
  const lastEntryKey = tagEntries.length > 0 && tagEntries[0][0];
  return map(tags, (tag, key) => {
    return (
      <CSSTransition
        key={tag.name}
        timeout={DURATIONS.DELETE_TAG}
        classNames="memoChip-tg"
      >
        {getChip(
          {
            isDeletable: true,
            ref: key === lastEntryKey ? ref : null,
          },
          tag
        )}
      </CSSTransition>
    );
  });
};
